var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex gap-2 text-center"},_vm._l((_vm.gramSuggestions),function(item,index){return _c('div',{key:`${index}${item.shown}`,staticClass:"flex-1 bg-grey-11 rounded cursor-pointer p-1",on:{"click":function($event){return _vm.useGram(item.value)}}},[_vm._v(" "+_vm._s(item.shown)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }